import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { ModuleFlagsService } from '../core/services/module-flags.service';

/**
 * Blocks the B2B Sales routes while the client has not switched the module
 * on (Configuration > B2B Sales). Runs after AuthGuard; the backend applies
 * the same rule, this just keeps a hidden page from rendering empty.
 */
export const b2bEnabledGuard: CanActivateFn = () => {
  const flags = inject(ModuleFlagsService);
  const router = inject(Router);
  return flags.ensureLoaded().pipe(
    map((loaded) =>
      loaded && flags.isEnabled(flags.KEYS.B2B_ENABLED)
        ? true
        : router.createUrlTree(['/unauthorized']),
    ),
  );
};
